import { combineReducers } from 'redux';
import { FirebaseReducer, firebaseReducer, FirestoreReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';

export type Profile = {
  id: string;
  email: string;
  name: string;
  inactive?: boolean;
  isAdmin?: boolean;
  parent?: string;
};

export type RootState = {
  firebase: FirebaseReducer.Reducer<Profile>;
  firestore: FirestoreReducer.Reducer;
};

export default combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
});
